import { ProfileTypes } from '@/constants/applicationProfile'
import { useListApplicationProfilesQuery } from '@/services/v2-application/applicationProfile'
import { ApplicationProfile } from '@/types/unlock'

export const getApplicationProfileByPosition = (applicationUUID: string, position: number) => {
  const { data: applicationProfiles } = useListApplicationProfilesQuery(applicationUUID, {
    skip: !applicationUUID,
  })

  return applicationProfiles?.results.find(
    (applicationProfile) => applicationProfile?.position === position
  )
}

const findSpouse = (profileId: string | null, appProfiles): ApplicationProfile | undefined => {
  return appProfiles.find((appProfile) => appProfile.id === profileId)
}

const profileTypeMapping = {
  [ProfileTypes.APPLICANT]: 'Applicant',
  [ProfileTypes.CO_OWNER]: 'Co-Owner',
  [ProfileTypes.NOO]: 'NOO',
}

export const getSpouseProfileTypeLabel = (
  appProfile: ApplicationProfile,
  appProfiles: ApplicationProfile[]
): string | null => {
  const spouse = findSpouse(appProfile?.married_to_profile, appProfiles)

  if (!spouse || !spouse.profile_type) return null

  return profileTypeMapping[spouse.profile_type] || null
}

export const getSpouseProfileName = (
  appProfile: ApplicationProfile,
  appProfiles: ApplicationProfile[]
): string | null => {
  const spouse = findSpouse(appProfile?.married_to_profile, appProfiles)

  if (!spouse?.profile?.full_name) return null

  return spouse.profile.full_name
}
